import React from 'react';
import Modal from 'react-modal';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import {NotificationManager} from "react-notifications";

import * as RaceActions from "../../../../actions/race"
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from '../../../reusable/UserFieldElement';
import config from "../../../../../../server/src/config";
import moment from "moment";
import {alert} from "../../../../utils/alertDialog";
import {ROUTE_IMPORT_FILE} from "../../../../constants/routeconstants";
import {Link} from "react-router";
import { ROUTE_DEVICES_EXPORT } from '../../../../constants/routeconstants';

class ExportDevicesDialog extends React.Component {

    static propTypes = {
        onClose: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            pigeonhole: '',
        }
    }

    fields = [];
    render() {
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {
                    this.props.onClose()
                }}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content: {
                        height: '200px',
                        width: '450px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title">Eksporter til elektroniske anlæg</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <table className="fields">
                                <tbody>
                                <tr>
                                    <td className="medium-vertical-spacing"><label htmlFor="pigeonhole">Slag</label></td>
                                    <td className="medium-vertical-spacing">
                                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={this.state.pigeonhole === '' ? '-- Vælg --' : false} className="field100p" containerClassName="display-inline-block field100p"
                                                          name="pigeonhole" id="pigeonhole" value={this.state.pigeonhole} options={
                                                              this.props.admin.pigeonHoles.filter(hole => hole.Foreningsnr === this.props.auth.currentEntity).sort((s1, s2) => s1.Slagnr < s2.Slagnr ? -1 : 1).map(pigeonhole => (
                                                                  {key: pigeonhole.Slagnr, value: pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' - ' + pigeonhole.Slagnavn)}
                                                              )).toArray()}
                                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[0] = instance; }}
                                        />
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="actions-row">
                        <Link className={"btn-primary" + (this.state.pigeonhole === '' ? ' disabled' : '')} to={this.state.pigeonhole === '' ? '' : ROUTE_DEVICES_EXPORT.replace(':club', this.props.auth.currentEntity).replace(':pigeonhole', this.state.pigeonhole)} target="_blank" title="Hent duebestand">Eksporter</Link>
                        <button className="btn-secondary float-right" onClick={() => {this.props.onClose()}}>Luk</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onCheckFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.checked});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };
}

const mapStateToProps = (state) => ({
    auth: {
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        pigeonHoles: state.admin.pigeonHoles,
    }
});

export default connect(mapStateToProps)(ExportDevicesDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/dialogs/ExportDevicesDialog.js